export interface SelectedPricing {
    id: number;
    plan_name: string;
    base_price: number;
    currency: string;
    description?: string;
    features?: string[];
}

export interface BrandRegistrationApplication {
    id: number;
    applicant_first_name: string;
    applicant_paternal_last_name: string;
    applicant_maternal_last_name: string;
    applicant_email: string;
    applicant_phone: string;
    mark_type: 'mixta' | 'figurativa' | 'denominativa';
    brand_name?: string;
    services_description: string;
    keywords?: string;
    brand_image?: string;
    status: 'pending' | 'review' | 'approved' | 'rejected';
    application_number: string;
    assigned_lawyer_id?: number;
    assigned_lawyer_name?: string;
    inapi_application_number?: string | null;
    selected_pricing?: SelectedPricing;
    created_at: string;
    updated_at: string;
    closing_date?: string;
    is_active: boolean;
    can_delete?: boolean;
}

export interface BrandRegistrationDataForm {
    applicant_first_name: string;
    applicant_paternal_last_name: string;
    applicant_maternal_last_name: string;
    applicant_email: string;
    applicant_phone: string;
    mark_type: 'mixta' | 'figurativa' | 'denominativa';
    brand_name?: string;
    services_description: string;
    keywords?: string;
    brand_image?: File | null;
    selected_pricing_id?: number | null;
}

export interface BrandRegistrationFilters {
    status?: string;
    search?: string;
    page?: number;
    per_page?: number;
}

export interface BrandRegistrationStatusUpdate {
    status: 'pending' | 'review' | 'approved' | 'rejected';
}

export interface MarkTypeOption {
    value: 'mixta' | 'figurativa' | 'denominativa';
    label: string;
}

export interface StatusOption {
    value: 'pending' | 'review' | 'approved' | 'rejected';
    label: string;
}

export interface BrandRegistrationCreateData {
    mark_types: MarkTypeOption[];
    status_options: StatusOption[];
}

// Brand Registration Verification (Paso 2: Verificación y factibilidad)
export interface BrandRegistrationClass {
    id: number;
    class_name: string;
    class_description?: string;
    fee: number;
    order: number;
}

export interface BrandRegistrationVerification {
    id: number;
    brand_registration_id: number;
    application_number: string;
    applicant_first_name: string;
    applicant_paternal_last_name: string;
    applicant_email: string;
    brand_name?: string;
    mark_type: 'mixta' | 'figurativa' | 'denominativa';
    feasibility_result: 'positive' | 'negative';
    feasibility_detail: string;
    classes: BrandRegistrationClass[];
    total_fees: number;
    created_at: string;
    updated_at: string;
    is_active: boolean;
}

export interface BrandRegistrationVerificationDataForm {
    brand_registration_id: number;
    feasibility_result: 'positive' | 'negative';
    feasibility_detail: string;
    classes: BrandRegistrationClassForm[];
}

export interface BrandRegistrationClassForm {
    class_name: string;
    class_description?: string;
    fee: number;
}

export interface FeasibilityResultOption {
    value: 'positive' | 'negative';
    label: string;
}

export const defaultBrandRegistrationVerificationDataForm: BrandRegistrationVerificationDataForm = {
    brand_registration_id: 0,
    feasibility_result: 'positive',
    feasibility_detail: '',
    classes: []
};

export const defaultBrandRegistrationDataForm: BrandRegistrationDataForm = {
    applicant_first_name: '',
    applicant_paternal_last_name: '',
    applicant_maternal_last_name: '',
    applicant_email: '',
    applicant_phone: '',
    mark_type: 'mixta',
    brand_name: '',
    services_description: '',
    keywords: '',
    brand_image: null,
    selected_pricing_id: null
};
